module.exports = "../study/imgs/maps/Kanagawa/S8/Agriculture/RiceQ/Kanagawa_RiceQ_MIROC5_RCP45_Mid.png";